define('modules/home/sidebar/views/alerts.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'moment',
    'modules/home/sidebar/views/base.customizable.sidebar.view',
    //'modules/base/models/user.setting.model',
    'modules/home/models/alert.summary.model',
    //'modules/home/sidebar/views/alert.view',
    'modules/base/views/base.search.reset.view',
      /* "text!modules/base/templates/base.search.reset.template.html",
    'text!modules/home/sidebar/templates/empty.alerts.template.html',
    'text!modules/home/sidebar/templates/empty.lists.results.template.html',*/
    'text!modules/home/sidebar/templates/alerts.template.html'
], function(
    Prospector,
    $,_,Backbone,
    Marionette,
    moment,
    BaseCustomizableSidebarView,
   // UserSettingModel,
    AlertSummaryModel,
    //AlertView,
    BaseSearchResetView,
     /* BaseSearchResetTemplate,
    EmptyResultsTemplate,
    EmptyListResultsTemplate,*/
    Template
){
    var AlertsView = BaseCustomizableSidebarView.extend({
        template: _.template(Template),
        /*resetTemplate: _.template(BaseSearchResetTemplate),
        emptyTemplate: _.template(EmptyResultsTemplate),
        emptyListResultsTemplate: _.template(EmptyListResultsTemplate),*/
        className: 'alertsDrawer',
        modelSelector: '.alertsHolder',
        sortFieldIndex: 2,
        sortDirectionIndex: 3,
        followingFilterIndex: 8,
        monitoringFilterIndex: 9,
        queueCounter: 0,
        refreshTrigger: 'refreshAlertDefaults',
        initialize:function(options){
            Prospector.on("refreshFollowing", this.canFetch, this);
            Prospector.on("decrementAlertsCounter", this.decrementIdentity, this);
            Prospector.on("incrementQueueCounter", this.incrementQueueCounter, this);
            BaseCustomizableSidebarView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new AlertSummaryModel();
        },
        procSearchForProfiles:function(){
            return 'dashboard';
        },
        onRender:function(){
            var baseSearchResetView = new BaseSearchResetView();
            this.$('.alertsFilterField').append(baseSearchResetView.render().el);
             /* this.$('.searchBar').attr("placeholder", "Search Alerts By Profile Name");*/ //change placeholder name
            BaseCustomizableSidebarView.prototype.onRender.call(this); //overrides parent view's onRender()
        },
        procResponse:function(){
            if(this.isFirstLoad){
                window.user.set({
                    summary: this.model.get('summary')
                });
                this.isFirstLoad = false;
                Prospector.trigger('refreshAlertsCount');
            }
            /*this.$(this.modelSelector).empty();
            if(this.model.get('identities').length > 0){
                this.$('.listEmpty').remove();
                _.each(this.model.get('identities'), function(identity){
                    var view = new AlertView({model: identity, parent:this});
                    this.$(this.modelSelector).append(view.render().el);
                    this.subviews.push(view);
                }, this);
            } else {
                if((this.model.query == undefined || this.model.query == "")
                    && this.model.followingFilter == "0"
                    && this.model.monitoringFilter == "0"
                ){
                    $(this.el).append(this.emptyTemplate);
                    this.$('.searchForProfiles').attr("href", "#" + this.procSearchForProfiles());

                } else {
                    this.$(this.modelSelector).append(this.emptyListResultsTemplate);
                }
            }*/
        },
        decrementIdentity:function(options){
            var then = new moment(options.dateTime);
            var now = new moment();
            var diff = now.diff(then, 'days');
            if(diff < 7){
                window.user.attributes.summary.recentUnreadMediaAlerts--;
            }
            window.user.attributes.summary.totalUnreadMediaAlerts--;
            var profileSettings = window.user.get('userSettings')[1].userSettingsLevel1;
            if(profileSettings[6].value.indexOf('nread') > -1){
                Prospector.trigger('refreshAlertsCount');

            }
            var view = _.filter(this.subviews, function(sv){
                return sv.model.get('id') == options.identityId;
            }, this);
            if(view != undefined && view != null && view.length > 0){
                var sv = view[0];
                if(diff < 7){
                    sv.model.attributes.recentUnreadMediaAlerts--;
                }
                sv.model.attributes.totalUnreadMediaAlerts--;
                sv.refreshLabels();
            }
        },
        refreshAlertsDrawer:function(){
            var profileSettings = window.user.get('userSettings')[1].userSettingsLevel1;
            this.defaultColumnSetting = new UserSettingModel(profileSettings[2]);
            this.defaultSortSetting = new UserSettingModel(profileSettings[3]);

            if((this.$('.sortField').val() != this.defaultColumnSetting.get('value')) || (this.getSortOrder() != this.defaultSortSetting.get('value'))){
                this.onRender();
            } else {
                _.each(this.subviews, function(sv){
                    sv.refreshLabels();
                }, this);
            }
        },
        incrementQueueCounter: function(){
            this.queueCounter++;
        },
        /**********************
         *
         * User Following Model
         *
         *********************/
        canFetch:function(options){
            if(this.followingCurrXHR != undefined && this.followingCurrXHR.readyState > 0 && this.followingCurrXHR.readyState < 4){
                this.followingCurrXHR.abort();
            }
            if(options != undefined){
                this.fetchFollowingModel(options);
            }
        },
        fetchFollowingModel:function(options){
            if (options.options.fromAlertsDrawer) {
                window.setTimeout($.proxy(this.decrementCounter, this), 5000 + (Math.random() * 10));
            }
            else {
                this.addLoader();
                this.listenToOnce(window.user.following, 'sync', this.fetchModel, this);
                this.followingCurrXHR = window.user.following.fetch();
            }
        },
        decrementCounter:function(){
            this.queueCounter -- ;
            if (this.queueCounter == 0) {
                this.listenToOnce(window.user.following, 'sync', this.fetchModelNoLoader, this);
                this.followingCurrXHR = window.user.following.fetch();
            }
        }
    });
    return AlertsView;
});

